import { render } from "./LoginMenuSvg.vue?vue&type=template&id=e045369e"
import script from "./LoginMenuSvg.vue?vue&type=script&lang=js"
export * from "./LoginMenuSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__